[
  {
    "id": "SWW-M8P-L304-001",
    "module": "SpellingWW",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "question": "Hij ... al drie keer gebeld. (proberen)",
    "options": ["probeerde", "probeert", "heeft geprobeerd", "geprobeerd"],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "werkwoordvormen",
    "subSkill": "voltooide_tijd_context",
    "familyId": "SWW-TIJD-VTDT-CONTEXT",
    "conceptId": "present_perfect_repeated_action_context",
    "variantIndex": 1,
    "explanation": "De zin gaat over iets dat al meerdere keren is gebeurd (al drie keer).\nDan gebruik je meestal de voltooide tijd: heeft geprobeerd.",
    "distractorExplanations": {
      "1": "Dit is verleden tijd. De zin gaat niet duidelijk over een afgesloten moment in het verleden, maar over iets dat al meerdere keren gebeurd is.",
      "2": "Dit is tegenwoordige tijd. Bij 'al drie keer' past voltooide tijd beter.",
      "3": "Dit is alleen het voltooid deelwoord. Je hebt ook een hulpwerkwoord nodig: heeft geprobeerd."
    }
  },
  {
    "id": "SWW-M8P-L304-002",
    "module": "SpellingWW",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "question": "De wedstrijd wordt door de scheidsrechter ... (fluiten).",
    "options": ["gefloten", "gefluit", "fluit", "floot"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "werkwoordvormen",
    "subSkill": "lijdende_vorm_sterk_werkwoord",
    "familyId": "SWW-LIJDENDE-VORM-STERK",
    "conceptId": "passive_voice_strong_verb",
    "variantIndex": 1,
    "explanation": "Bij een lijdende vorm gebruik je: wordt + voltooid deelwoord.\n'Fluiten' is een sterk werkwoord.\nHet voltooid deelwoord is: gefloten.",
    "distractorExplanations": {
      "1": "Dit lijkt logisch, maar het voltooid deelwoord van fluiten is niet gefluit maar gefloten.",
      "2": "Dit is tegenwoordige tijd en past niet na 'wordt'.",
      "3": "Dit is verleden tijd. In de zin staat 'wordt', dus je hebt het voltooid deelwoord nodig."
    }
  },
  {
    "id": "SWW-M8P-L304-003",
    "module": "SpellingWW",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "question": "Hij ... zijn excuses aan. (bieden)",
    "options": ["biedt", "bied", "bood", "geboden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_pv_dt",
    "familyId": "SWW-TT-DT-PV",
    "conceptId": "present_tense_third_person_dt",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij', dus tegenwoordige tijd is stam + t.\nHet hele werkwoord is 'bieden'. Stam is 'bied'.\nBied + t = biedt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: ik bied. Bij 'hij' hoort biedt.",
      "2": "Dit is verleden tijd. In de zin gaat het om wat hij nu doet.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft geboden."
    }
  },
  {
    "id": "SWW-M8P-L304-004",
    "module": "SpellingWW",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "question": "De ... afspraken zijn belangrijk. (maken)",
    "options": ["gemaakte", "gemaakt", "maakten", "maakte"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bnvd_meervoud",
    "familyId": "SWW-BNVD-E-MEERVOUD",
    "conceptId": "bnvd_plural_from_past_participle",
    "variantIndex": 3,
    "explanation": "Je beschrijft de afspraken, dus je gebruikt het bijvoeglijk gebruikte voltooid deelwoord.\nHet voltooid deelwoord van 'maken' is gemaakt.\nBij meervoud komt er een -e achter: gemaakte afspraken.",
    "distractorExplanations": {
      "1": "Dit is het voltooid deelwoord zonder -e. In deze zin beschrijf je de afspraken, dus je hebt -e nodig.",
      "2": "Dit is verleden tijd meervoud. De zin vraagt om een beschrijving, niet om een persoonsvorm.",
      "3": "Dit is verleden tijd enkelvoud. Ook dit past niet in de zin."
    }
  }


]
